export var getSanitizedText = function (text) { return text === null || text === void 0 ? void 0 : text.replace(/(<([^>]+)>)/gi, "").replaceAll("&nbsp;", " "); };
export var insertSpaces = function (text) {
    return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        .replace(/(\d+)/g, function (_, num) { return " " + num + " "; });
};
export var hasTextUrl = function (text) {
    return new RegExp(/(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/).test(text);
};
//# sourceMappingURL=textUtils.js.map